import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageHeader";
import { ListChecks } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";

export const Route = createFileRoute("/_auth/interventions/")({
  component: Interventions,
});

function Interventions() {
  return (
    <>
      <PageHeader title="Interventions" />
      <main className="h-full overflow-y-auto bg-slate-100 p-6">
        <EmptyState
          title="Interventions"
          description="Low Carbon Technologies will soon provide customized recommendations to help you optimize your operation and cattle to meet or exceed certification requirement. Identify opportunities, receive actionable strategies, track implementation progress and maximize value all in one place."
          Icon={ListChecks}
        />
      </main>
    </>
  );
}
